export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand-mark ${compact ? 'brand-mark--compact' : ''}`}>
      <span className="brand-mark__sigil" aria-hidden="true">✦</span>
      <div>
        <strong>Spellbound</strong>
        <span>Salon Concierge</span>
      </div>
    </div>
  )
}
